/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Detail_No_CompaniesInputs */

const en_admin_user_detail_no_companies = /** @type {(inputs: Admin_User_Detail_No_CompaniesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User does not belong to any company.`)
};

const de_admin_user_detail_no_companies = /** @type {(inputs: Admin_User_Detail_No_CompaniesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer gehört zu keinem Unternehmen.`)
};

/**
* | output |
* | --- |
* | "User does not belong to any company." |
*
* @param {Admin_User_Detail_No_CompaniesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_detail_no_companies = /** @type {((inputs?: Admin_User_Detail_No_CompaniesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Detail_No_CompaniesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_detail_no_companies(inputs)
	return en_admin_user_detail_no_companies(inputs)
});